import React from "react";

function RadioButton({ label, name, checked = false, className = "" }) {
  return (
    <div className={`flex flex-wrap gap-1 items-start w-full ${className}`}>
      <div className="flex gap-2 justify-center items-center w-5 min-h-[22px]">
        <div className="flex flex-col justify-center self-stretch p-0.5 my-auto w-5">
          <div className="flex shrink-0 h-4 rounded-full border border-gray-200 border-solid" />
        </div>
      </div>
      <label className="flex-1 shrink text-sm leading-loose text-gray-700 basis-0 min-w-60 max-md:max-w-full">
        {label}
      </label>
    </div>
  );
}

export default RadioButton;
